<template>
  <div>
    <page-header title="Backlog" ></page-header>
    <b-container>
      <p>{{filteredMembers.length}} in backlog</p>
      <b-table :items="filteredMembers" hover :fields="fields" primary-key="id" v-if="filteredMembers && filteredMembers.length">
        <template v-slot:cell(name)="data">
          <span v-router-link="{name:'MemberDetail',params:{id:data.item.id}}">{{data.item.name}}</span>
        </template>
      </b-table>
      <b-spinner v-else-if="$apollo.queries.members.$loading"></b-spinner>
      <div v-else class="inbox-zero">
        <img class="mb-5" :src="winning">
        <h3>There's no one to call</h3>
        <p>You're a hero!</p>
      </div>
    </b-container>
  </div>
</template>
<script>
import { ListBacklog, ListBacklogSubscription } from '@/gql/members/ListBacklog.gql';
import PageHeader from '@/components/global/PageHeader';

export default {
  components: {
    PageHeader,
  },
  data (){
    const now = new Date();
    return {
      since: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 7),
      fields: [
        'name',
        {
          key: 'createdAt',
          label: 'Joined',
          formatter: value => {
            return this.$moment(value).fromNow()
          }
        },
        {
          key: 'timezone',
          label: 'Local Time',
          formatter: value => {
            return this.$moment.tz(value).format('HH:mm')
          }
        },
        {
          key: 'location',
          label: 'Location',
          formatter: value => {
            return value ? `${value.city}, ${value.country_name}` : '';
          }
        },
        {
          key: 'completedAt',
          label: 'Registration',
          formatter: value => {
            return value ? 'Completed' : 'In Progress';
          }
        },
        'score',
        'attemptCount',
      ]
    };
  },
  computed: {
    filteredMembers() {
      if (this.members) {
        return this.members.map((member) => {
          const lastAttempt = new Date(member.outboundCalls_aggregate.aggregate.max.createdAt).getTime();
          const elapsed = Date.now() - lastAttempt;
          const localHour = this.$moment.tz(new Date(), member.timezone).format('HH') * 1;
          member.localHour = localHour || 0;
          member.attemptCount = member.outboundCalls_aggregate.aggregate.count;
          member.allowed = (elapsed > (1000*60*60*24)
            && (8 < localHour)
            && (localHour < 19)
          );
          member._rowVariant = member.allowed ? 'success' : 'danger';
          return member;
        })
        .filter((member) => (member.attemptCount < 3))
        .sort((a, b) => (a.localHour - b.localHour))
        .sort((a, b) => (b.allowed - a.allowed));
      }
    },
    winning() {
      return 'https://picsum.photos/800/300';
    }
  },
  apollo: {
    members: {
      query: ListBacklog,
      variables() {
        return {
          since: this.since,
        }
      },
      subscribeToMore: {
        document: ListBacklogSubscription,
        variables() {
          return {
            since: this.since,
          };
        },
        updateQuery(previousResult, { subscriptionData }) {
          // console.log('Update', previousResult);
          // console.log('SD', subscriptionData);
        }
      }
    },
  },
};
</script>
<style scoped>
  .inbox-zero
  {
    border: dashed 3px #efefef;
    padding:20px;
    text-align:center;
  }
  .inbox-zero img
  {
    width:800px;
    height:300px;
  }
</style>
